import { useMatch } from 'react-router-dom';

import { useAndiChatEnabled } from './useAndiChatEnabled';

/** Whether an Andi page is open, for a project whose org can use Andi. Until the project's andiChat
 *  entitlement says yes, the app keeps its own sidebar and starts no Andi runtime, so nobody sees Andi, or
 *  calls its API, before that's known. */
export const useOnAndiPage = () => {
  const onAndiRoute = Boolean(useMatch('/projects/:projectId/andi/*'));
  const enabled = useAndiChatEnabled();
  return onAndiRoute && enabled === true;
};
